import React, { useRef, useState, useEffect } from 'react'
import './style.scss'

const TextCarousel = ({ textTimes, className, carouselDelayOffset }) => {

  // add ref for text carousel container
  const textCarouselContainerRef = useRef()

  useEffect(() => {
    let currentItemIndex = Math.floor(Math.random() * textTimes.length);
    const carousel = textCarouselContainerRef.current;

    function updateCarousel() {
      carousel.innerHTML = `<div class="text-carousel-container_item">${textTimes[currentItemIndex]}</div>`;

      currentItemIndex++;
      if (currentItemIndex >= textTimes.length) {
        currentItemIndex = 0;
      }
    }

    let carouselInterval = null;

    carouselDelayOffset = carouselDelayOffset || 0;
    
    // set timeout
    setTimeout(() => {
      carouselInterval = setInterval(updateCarousel, 5 * 1000);
      updateCarousel();
    }, carouselDelayOffset * 1000);

    return () => {
      clearInterval(carouselInterval);
    }
  }, []);

  return (
    <div className={`text-carousel-container ${className || ''}`} id="text-carousel-container" ref={textCarouselContainerRef}>
    </div>
  );
};

export default TextCarousel
